export enum AuditEntityParentType {
  PROJECT_INVESTOR_DATA = 'ProjectInvestorData',  
  PROJECT = 'Project',
  INVESTOR = 'Investor',
  ASSET_MANAGER = 'InvestorAssetManagerLookup',
  FUND = 'InvestorFundLookup',
  INVESTOR_BENEFICIARY = 'InvestorBeneficiary'
}
